import { NameId } from "@common/types/NameId";

enum DealTypeEnum {
  Aftermarket = 4,
  C2CFinancing = 5,
}

export const dealTypes: NameId[] = [
  {
    name: "Aftermarket",
    id: DealTypeEnum.Aftermarket.toString(),
  },
  {
    name: "C2C Financing",
    id: DealTypeEnum.C2CFinancing.toString(),
  },
].sort((a, b) => a.name.localeCompare(b.name));

export const getDealTypeById = (id: string): NameId | undefined =>
  dealTypes.find((dt) => dt.id === id);

export default DealTypeEnum;
